function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Plugins, Context } from '@leverege/plugin';
import { Dialog } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import { LoadingView } from '@leverege/molten/views';
import { ViewUtils } from '@leverege/molten/imagine';
import { fromPathValue } from '@leverege/object-util';
import FotaItemEditor from "../itemEditor/FotaItemEditor.js";
import { Names } from "../../constants/index.js";
export default function UpdateItem(props) {
  const {
    show,
    onClose,
    objectType,
    reloadData,
    delegate,
    relationship,
    target
  } = props;
  const name = Attributes.get('name', objectType, target?.data);
  const editorProps = {
    title: `Update ${name || Names[objectType]}`,
    reloadData,
    delegate,
    relationship,
    target,
    mode: 'edit',
    attributeOptionKey: 'editOptions',
    submitFormat: 'patch',
    onSubmit: async ({
      value
    }) => {
      const closeLoading = LoadingView.showDialog(`Updating ${Names[objectType]}`);
      try {
        let patch = value;
        const plgs = Plugins.get('ItemUpdateHook', m => {
          return Context.isMatch({
            objectType,
            path: relationship.path
          }, m);
        });
        for (let n = 0; n < plgs.length; n++) {
          // eslint-disable-next-line no-await-in-loop
          patch = await plgs[n].hook(patch, {
            delegate,
            relationship,
            target
          });
        }
        const res = await GlobalState.dispatch(delegate.update(fromPathValue(patch)));
        closeLoading();
        ViewUtils.handleFormResult(res, {
          delegate,
          blueprint: relationship.blueprint,
          relationship,
          component: UpdateItem,
          type: 'edit'
        });
      } catch (err) {
        console.log(err);
        closeLoading();
        ViewUtils.handleFormError(err, {
          delegate,
          blueprint: relationship.blueprint,
          target,
          relationship,
          component: nProps => /*#__PURE__*/React.createElement(UpdateItem, _extends({}, props, nProps)),
          type: 'edit'
        });
      }
      onClose();
      reloadData();
    }
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    closeOnDocumentClick: false,
    closeOnEscape: false,
    show: show,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(FotaItemEditor, _extends({}, props, editorProps, {
    onCancel: onClose
  })));
}